import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import type { IInsightMetric } from '../interfaces';

interface IInsightCardProps {
  title: string;
  metrics: IInsightMetric[];
  color: string;
}

export const InsightCard: React.FC<IInsightCardProps> = ({ title, metrics, color }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 3,
      borderRadius: 4,
      position: 'relative',
      overflow: 'hidden',
      transition: 'box-shadow 0.2s',
      '&:hover': { boxShadow: 2 },
    }}
  >
    <Typography
      variant="caption"
      sx={{
        fontWeight: 800,
        color: 'text.secondary',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        display: 'block',
        mb: 3,
      }}
    >
      {title}
    </Typography>
    <Stack spacing={2}>
      {metrics.map((metric) => (
        <Box key={metric.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
            {metric.label}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
            {metric.value}
          </Typography>
        </Box>
      ))}
    </Stack>
    <Divider sx={{ my: 2.5 }} />
    <LinearProgress
      variant="determinate"
      value={66}
      sx={{
        height: 6,
        borderRadius: 3,
        bgcolor: 'action.hover',
        '& .MuiLinearProgress-bar': {
          bgcolor: color === 'blue' ? 'info.main' : color === 'amber' ? 'warning.main' : 'primary.main',
          borderRadius: 3,
        },
      }}
    />
  </Paper>
);
